import { useEffect, useState } from "react";
import { getParkingCountValue, NumberInputField } from "../utility/Utils";
import { updateRuleValue } from "../../store/actions";
import { useDispatch } from "react-redux";

const ParkingField = ({ tagAllLists, matchId, type }) => {
  const dispatch = useDispatch();
  const defaultValue = getParkingCountValue(tagAllLists, matchId);
  const [value, setValue] = useState(defaultValue);

  // Dispatch initial default value to Redux on mount
  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null) {
      dispatch(
        updateRuleValue({
          propName: "changedParkingOccupancy",
          value: defaultValue,
        })
      );
    }
  }, [defaultValue]);

  return (
    <NumberInputField
      helpertext={`Number of spaces in ${
        type == "area" || type == "sub-area" ? "floor" : type
      }`}
      value={value}
      onChange={(newValue) => {
        setValue(newValue);
        if (newValue !== defaultValue) {
          dispatch(
            updateRuleValue({
              propName: "changedParkingOccupancy",
              value: newValue,
            })
          );
        } else {
          dispatch(
            updateRuleValue({
              propName: "changedParkingOccupancy",
              value: defaultValue,
            })
          );
        }
      }}
    />
  );
};

export default ParkingField;
